import React, { Fragment, useMemo, memo } from 'react';
// Mui
import InputAdornment from '@material-ui/core/InputAdornment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
// Tvendo
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

function MultiCompleteForFilter(props) {
  const {
    label,
    textField,
    loading = false,
    disabled = false,
    selectAll = false,
    limitTags = undefined,
    fullWidth = true,
  } = props;
  const { selected, setSelected } = props;
  const { options = [], onSelectionChange } = props;

  const memoizedOptions = useMemo(() => {
    if (selectAll === false) return options;
    if (options.length === 0) return options;

    return [{ id: 'SELECCIONAR_TODO', [textField]: 'Todos' }, ...options];
  }, [options, selectAll]);

  function onChange(_, selecteds) {
    // Validando que no esté haciendo click en 'Todos'
    if (selectAll) {
      if (selecteds.length > 0) {
        let index = selecteds.findIndex((item) => item.id === 'SELECCIONAR_TODO');
        if (index !== -1) {
          if (selected.length === 0) {
            // Seleccionar todo todo
            setSelected(options);
            if (onSelectionChange) onSelectionChange(options);
          } else if (selected.length - 1 === options.length) {
            setSelected([]);
            if (onSelectionChange) onSelectionChange([]);
          } else {
            setSelected([]);
            if (onSelectionChange) onSelectionChange([]);
          }
          return;
        }
      }
    }

    setSelected(selecteds);
    if (onSelectionChange) onSelectionChange(selecteds);
  }

  function renderOption(option, state) {
    // Si la opcion es 'Todo'
    if (selectAll && option.id === 'SELECCIONAR_TODO') {
      return (
        <Fragment>
          <Checkbox
            style={{ marginRight: 8 }}
            checked={selected.length === options.length}
            indeterminate={selected.length > 0 && selected.length < options.length}
          />
          {option[textField]}
        </Fragment>
      );
    }

    return (
      <Fragment>
        <Checkbox style={{ marginRight: 8 }} checked={state.selected} />
        {option[textField]}
      </Fragment>
    );
  }

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      limitTags={limitTags}
      renderOption={renderOption}
      options={memoizedOptions}
      getOptionLabel={(item) => item[textField]}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="normal"
          fullWidth={fullWidth}
          // required
          InputProps={{
            ...params.InputProps,
            startAdornment: loading ? (
              <InputAdornment position="start">
                <LoadingSpinner
                  styles={{
                    width: '15px',
                    height: '15px',
                    borderWidth: '4px',
                    margin: '-5px',
                  }}
                />
              </InputAdornment>
            ) : (
              params.InputProps.startAdornment
            ),
          }}
        />
      )}
      disabled={disabled}
      value={selected}
      onChange={onChange}
    />
  );
}

export default memo(MultiCompleteForFilter);

